import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { content, type Content, type Lang } from '../data/translations';
type LanguageValue = {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: Content;
};
const STORAGE_KEY = 'facdc-language';
const LanguageContext = createContext<LanguageValue | null>(null);
function readStored(fallback: Lang): Lang {
  if (typeof window === 'undefined') return fallback;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === 'en' || stored === 'es') return stored;
  if (window.navigator?.language?.toLowerCase().startsWith('es')) return 'es';
  return fallback;
}
export function LanguageProvider({
  children,
  defaultLanguage = 'en'
}: {
  children: React.ReactNode;
  defaultLanguage?: Lang;
}) {
  const [lang, setLang] = useState<Lang>(() => readStored(defaultLanguage));
  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const value = useMemo<LanguageValue>(() => ({
    lang,
    setLang,
    t: content[lang]
  }), [lang]);
  return <LanguageContext.Provider value={value} data-id="element-414" data-mp="3cxr9c24rje96">{children}</LanguageContext.Provider>;
}
export function useLanguage(): LanguageValue {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used inside a LanguageProvider');
  return ctx;
}